import { useContext } from 'react';
import { IUserAccessContext, UserAccessContext } from '../../store/userAccess.context';

export function useUserAccess(): IUserAccessContext {
  return useContext(UserAccessContext) as IUserAccessContext;
}
